import { render } from "./chart-doughnut-legend-card.vue?vue&type=template&id=29bed0fb"
import script from "./chart-doughnut-legend-card.vue?vue&type=script&lang=js"
export * from "./chart-doughnut-legend-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/charts/chart-doughnut-legend-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29bed0fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29bed0fb', __exports__)) {
    api.reload('29bed0fb', __exports__)
  }
  
  module.hot.accept("./chart-doughnut-legend-card.vue?vue&type=template&id=29bed0fb", () => {
    api.rerender('29bed0fb', render)
  })

}


export default __exports__